import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-punjabi',
  templateUrl: './punjabi.component.html',
  styleUrls: ['./punjabi.component.scss']
})
export class PunjabiComponent implements OnInit {
  constructor() { }
  ngOnInit(): void { }
}
